var map = {
	"./pt/1/image2.png": [
		75069,
		5069
	],
	"./pt/10/image2.png": [
		9524,
		9524
	],
	"./pt/2/image2.png": [
		5737,
		5737
	],
	"./pt/3/image2.png": [
		2807,
		2807
	],
	"./pt/4/image2.png": [
		83913,
		3913
	],
	"./pt/5/image2.png": [
		76210,
		6210
	],
	"./pt/6/image2.png": [
		65800,
		5800
	],
	"./pt/7/image2.png": [
		18324,
		8324
	],
	"./pt/8/image2.png": [
		51929,
		1929
	],
	"./pt/9/image2.png": [
		34983,
		4983
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 44669;
module.exports = webpackAsyncContext;